import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
const RejectionNoteModal = ({
  isOpen,
  rejectionNote,
  onHide
}) => /*#__PURE__*/React.createElement(Modal, {
  isOpen: isOpen,
  toggle: onHide,
  backdrop: "static",
  keyboard: false
}, /*#__PURE__*/React.createElement(ModalHeader, null, "Report Rejected"), /*#__PURE__*/React.createElement(ModalBody, null, rejectionNote), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
  className: "t-button-ok",
  onClick: onHide
}, "Ok")));
RejectionNoteModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rejectionNote: PropTypes.string.isRequired
};
export default RejectionNoteModal;